<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="1342"></ucMenu>
					<div class="right_con">
						<div class="record_main">
							<el-card shadow="never" style="min-height:650px;">
								<!-- 标题 -->
								<div class="board_title">
									<h3>商品看板</h3>
									<div class="board_title_actions">
										<el-button size="small" @click="openGroupManageDialog">分组管理</el-button>
										<el-button size="small" type="primary" :disabled="selectedRows.length === 0" @click="openBatchGroupDialog()">批量设置分组</el-button>
									</div>
								</div>
								<!-- 筛选区域 -->
								<div class="filter_wrap">
									<!-- 平台类型 Tab -->
									<div class="platform_tabs_wrap">
										<span class="platform_tab" :class="{active: searchData.platform === 1}" @click="handlePlatformTab(1)">抖店</span>
										<span class="platform_tab" :class="{active: searchData.platform === 7}" @click="handlePlatformTab(7)">微信小店</span>
									</div>
									<div class="filter_row">
										<div class="filter_item">
											<span class="filter_label">店铺名称：</span>
											<el-select v-model="searchData.shop_id" placeholder="全部" clearable size="small" style="width:160px" filterable>
												<el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
											</el-select>
										</div>
										<div class="filter_item">
											<span class="filter_label">商品ID：</span>
											<el-input v-model="searchData.product_id" placeholder="商品ID" clearable size="small" style="width:140px"></el-input>
										</div>
										<div class="filter_item">
											<span class="filter_label">商品名称：</span>
											<el-input v-model="searchData.product_name" placeholder="商品名称" clearable size="small" style="width:150px"></el-input>
										</div>
										<div class="filter_item">
											<span class="filter_label">商品分组：</span>
											<el-select v-model="searchData.group_id" placeholder="全部分组" clearable size="small" style="width:150px" filterable>
												<el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</div>
										<!-- 抖店才有售卖类型和载体类型 -->
										<div class="filter_item" v-if="searchData.platform !== 7">
											<span class="filter_label">售卖类型：</span>
											<el-select v-model="searchData.sales_type" placeholder="全部" size="small" style="width:120px">
												<el-option v-for="item in salesTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
										<div class="filter_item" v-if="searchData.platform !== 7">
											<span class="filter_label">载体类型：</span>
											<el-select v-model="searchData.carrier_type" placeholder="全部" size="small" style="width:120px">
												<el-option v-for="item in carrierTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</div>
										<div class="filter_item" v-if="searchData.platform !== 7">
											<el-button size="small" @click="showRangeFilters = !showRangeFilters" style="margin-left:10px">
												{{ showRangeFilters ? '收起筛选' : '更多筛选' }}
												<i :class="showRangeFilters ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
											</el-button>
										</div>
									</div>
									<!-- 区间筛选（仅抖店显示）-->
									<div class="filter_row" v-if="searchData.platform !== 7 && showRangeFilters">
										<div class="filter_item">
											<span class="filter_label">曝光区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.exposure_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('exposure')">
													<el-option v-for="item in exposureRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.exposure_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.exposure_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.exposure_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">点击量区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.click_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('click')">
													<el-option v-for="item in clickRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.click_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.click_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.click_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">点击率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.click_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('click_rate')">
													<el-option v-for="item in clickRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.click_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.click_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.click_rate_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<div class="filter_row" v-if="searchData.platform !== 7 && showRangeFilters">
										<div class="filter_item">
											<span class="filter_label">加购率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.cart_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('cart_rate')">
													<el-option v-for="item in cartRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.cart_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.cart_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.cart_rate_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">加购量区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.cart_count_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('cart_count')">
													<el-option v-for="item in cartCountRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.cart_count_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.cart_count_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.cart_count_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">转化率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.conversion_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('conversion_rate')">
													<el-option v-for="item in conversionRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.conversion_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.conversion_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.conversion_rate_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<div class="filter_row" v-if="searchData.platform !== 7 && showRangeFilters">
										<div class="filter_item">
											<span class="filter_label">真实订单区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.real_order_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('real_order')">
													<el-option v-for="item in realOrderRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.real_order_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.real_order_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.real_order_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">异常订单区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.abnormal_order_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('abnormal_order')">
													<el-option v-for="item in abnormalOrderRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.abnormal_order_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.abnormal_order_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.abnormal_order_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">退货率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.return_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('return_rate')">
													<el-option v-for="item in returnRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.return_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.return_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.return_rate_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<!-- 微信平台更多筛选按钮 -->
									<div class="filter_row" v-if="searchData.platform === 7">
										<div class="filter_item">
											<el-button size="small" @click="showWechatRangeFilters = !showWechatRangeFilters">
												{{ showWechatRangeFilters ? '收起筛选' : '更多筛选' }}
												<i :class="showWechatRangeFilters ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
											</el-button>
										</div>
									</div>

									<div class="filter_row" v-if="searchData.platform === 7 && showWechatRangeFilters">
										<div class="filter_item">
											<span class="filter_label">点击次数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_click_cnt_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_click_cnt')">
													<el-option v-for="item in wechatClickCntRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_click_cnt_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_click_cnt_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_click_cnt_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">点击人数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_click_ucnt_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_click_ucnt')">
													<el-option v-for="item in wechatClickUcntRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_click_ucnt_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_click_ucnt_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_click_ucnt_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">加购人数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_add_cart_uv_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_add_cart_uv')">
													<el-option v-for="item in wechatAddCartUvRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_add_cart_uv_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_add_cart_uv_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_add_cart_uv_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<div class="filter_row" v-if="searchData.platform === 7 && showWechatRangeFilters">
										<div class="filter_item">
											<span class="filter_label">下单订单数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_pay_cnt_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_pay_cnt')">
													<el-option v-for="item in wechatPayCntRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_pay_cnt_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_pay_cnt_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_pay_cnt_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">成交订单数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_net_pay_cnt_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_net_pay_cnt')">
													<el-option v-for="item in wechatNetPayCntRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_net_pay_cnt_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_net_pay_cnt_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_net_pay_cnt_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">退款订单数区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_refund_cnt_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_refund_cnt')">
													<el-option v-for="item in wechatRefundCntRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_refund_cnt_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_refund_cnt_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_refund_cnt_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<div class="filter_row" v-if="searchData.platform === 7 && showWechatRangeFilters">
										<div class="filter_item">
											<span class="filter_label">点击成交率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_click_pay_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_click_pay_rate')">
													<el-option v-for="item in wechatClickPayRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_click_pay_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_click_pay_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_click_pay_rate_max" placeholder="最大值" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
										<div class="filter_item">
											<span class="filter_label">成交退款率区间：</span>
											<div style="display:flex;flex-direction:column;gap:8px">
												<el-select v-model="searchData.wechat_refund_rate_range" placeholder="全部" clearable size="small" style="width:180px" @change="handleRangeChange('wechat_refund_rate')">
													<el-option v-for="item in wechatRefundRateRangeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
												</el-select>
												<div v-if="searchData.wechat_refund_rate_range === 'custom'" style="display:flex;align-items:center;gap:6px">
													<el-input v-model="rangeCustom.wechat_refund_rate_min" placeholder="最小值" size="small" type="number" style="width:85px"></el-input>
													<span style="color:#909399">~</span>
													<el-input v-model="rangeCustom.wechat_refund_rate_max" placeholder="最大��" size="small" type="number" style="width:85px"></el-input>
												</div>
											</div>
										</div>
									</div>
									<div class="filter_row">
										<div class="filter_item">
											<span class="filter_label">时间：</span>
											<span class="time_tag" :class="{active: timeSelectId === item.id}" v-for="item in timeOptions" :key="item.id" @click="timeTagClick(item)">{{item.name}}</span>
											<el-date-picker
												v-model="customDateRange"
												type="daterange"
												range-separator="-"
												size="small"
												value-format="yyyy-MM-dd"
												start-placeholder="开始日期"
												end-placeholder="结束日期"
												:picker-options="datePickerOptions"
												@change="customDateChange"
												style="width:230px;margin-left:8px;">
											</el-date-picker>
										</div>
										<div class="filter_btns">
											<span v-if="selectedRows.length > 0" class="selected_hint">已选 {{ selectedRows.length }} 个商品</span>
											<el-button type="primary" size="small" @click="handleSearch">查询</el-button>
											<el-button size="small" @click="handleReset">重置</el-button>
											<el-button size="small" @click="openFieldConfig">指标配置</el-button>
										</div>
									</div>
								</div>

								<!-- 数据表格 -->
								<el-table
									:data="tableData"
									:header-cell-style="headerCellStyle"
									v-loading="loading"
									border
									size="small"
									style="width:100%;margin-top:15px;"
									:row-class-name="tableRowClass"
									@selection-change="handleSelectionChange">
									<el-table-column type="selection" width="46" fixed="left"></el-table-column>
									<!-- 固定列：店铺名称（包含平台标记）-->
									<el-table-column v-if="!hideLeftColumns" align="left" prop="shop_name" label="店铺" width="130" fixed="left" class-name="col-fixed">
										<template slot-scope="scope">
											<div class="shop_name_cell">
												<div class="shop_name">{{scope.row.shop_name}}</div>
												<div class="platform_tag_small" :class="platformClass(scope.row.platform)">{{platformName(scope.row.platform)}}</div>
											</div>
										</template>
									</el-table-column>
									<!-- 固定列：ID -->
									<el-table-column align="center" prop="product_id" :width="hideLeftColumns ? 140 : 100" fixed="left" class-name="col-fixed">
										<template slot="header">
											<div class="column_header_with_action">
												<span>ID</span>
												<el-button v-if="hideLeftColumns" type="text" size="mini" @click="toggleLeftColumns(false)">显示</el-button>
											</div>
										</template>
										<template slot-scope="scope">
											<div class="id_cell">
												<span class="id_text">{{scope.row.product_id}}</span>
												<div v-if="scope.row.group_name" class="id_group_tag">{{scope.row.group_name}}</div>
												<div v-else class="group_empty group_empty_tag">未分组</div>
											</div>
										</template>
									</el-table-column>
									<!-- 固定列：标题 -->
									<el-table-column v-if="!hideLeftColumns" align="left" prop="title" min-width="200" fixed="left" class-name="col-fixed" show-overflow-tooltip>
										<template slot="header">
											<div class="column_header_with_action">
												<span>标题</span>
												<el-button type="text" size="mini" @click="toggleLeftColumns(true)">隐藏</el-button>
											</div>
										</template>
										<template slot-scope="scope">
											<span class="title_text">{{scope.row.title}}</span>
										</template>
									</el-table-column>
									<!-- 可配置指标列 -->
									<el-table-column
										v-for="col in activeFields"
										:key="col.key"
										align="right"
										:prop="col.key"
										:width="col.width || 95"
										class-name="col-config">
										<template slot="header">
											<el-tooltip v-if="col.tip" :content="col.label" placement="top" effect="light">
												<span class="col_header">{{col.short}}</span>
											</el-tooltip>
											<span v-else class="col_header">{{col.short}}</span>
										</template>
										<template slot-scope="scope">
											<span :class="cellClass(col, scope.row[col.key])">{{formatCell(col, scope.row[col.key])}}</span>
										</template>
									</el-table-column>
								</el-table>

								<div class="turn_page">
									<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="loadData" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,50,100]"/>
								</div>
							</el-card>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>

		<!-- 指标配置弹窗 -->
		<el-dialog title="指标配置" :visible.sync="showFieldConfig" width="720px" @close="onConfigClose">
			<div class="field_config_body">
				<div class="field_group" v-for="group in configFields" :key="group.name">
					<div class="group_title">
						<el-checkbox :indeterminate="isGroupIndeterminate(group)" :value="isGroupAllChecked(group)" @change="toggleGroupAll(group, $event)">{{group.name}}</el-checkbox>
						<span class="group_count">{{getGroupCheckedCount(group)}} / {{group.fields.length}}</span>
					</div>
					<el-checkbox-group v-model="tempSelectedFields">
						<el-checkbox v-for="field in group.fields" :key="field.key" :label="field.key" :disabled="field.locked">{{field.label}}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="showFieldConfig = false">取消</el-button>
				<el-button size="small" type="primary" @click="confirmFieldConfig">确认</el-button>
			</span>
		</el-dialog>

		<el-dialog title="商品分组管理" :visible.sync="groupManageVisible" width="640px" custom-class="product-group-manage-dialog">
			<div class="group_manage_toolbar">
				<el-button size="small" type="primary" @click="handleAddGroup">新增分组</el-button>
			</div>
			<div class="group_manage_body">
				<el-table :data="groupList" size="small" border v-loading="groupLoading" :max-height="360">
					<el-table-column prop="name" label="分组名称" min-width="180"></el-table-column>
					<el-table-column prop="product_count" label="商品数" width="90" align="center"></el-table-column>
					<el-table-column prop="sort" label="排序" width="90" align="center"></el-table-column>
					<el-table-column label="操作" width="150" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="handleEditGroup(scope.row)">编辑</el-button>
							<el-button type="text" size="small" @click="handleDeleteGroup(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-empty v-if="groupList.length === 0 && !groupLoading" description="暂无分组" :image-size="90"></el-empty>
			</div>
		</el-dialog>

		<el-dialog :title="groupFormEdit ? '编辑分组' : '新增分组'" :visible.sync="groupFormVisible" width="400px">
			<el-form :model="groupForm" label-width="80px">
				<el-form-item label="分组名称">
					<el-input v-model="groupForm.name" maxlength="50" show-word-limit placeholder="请输入分组名称"></el-input>
				</el-form-item>
				<el-form-item label="排序值">
					<el-input-number v-model="groupForm.sort" :min="0" :max="9999" style="width:100%;"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="groupFormVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="groupFormLoading" @click="submitGroupForm">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="设置商品分组" :visible.sync="batchGroupVisible" width="420px">
			<el-form label-width="90px">
				<el-form-item label="已选商品">
					<div class="batch_group_tip">{{ batchGroupRows.length }} 个</div>
				</el-form-item>
				<el-form-item label="选择分组">
					<el-select v-model="batchGroupId" placeholder="请选择分组" clearable style="width:100%;">
						<el-option label="移出分组" :value="0"></el-option>
						<el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="batchGroupVisible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="batchGroupLoading" @click="submitBatchSetGroup">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import Pagination from "@/components/pagination/pagination.vue";
import { mapActions, mapState } from "vuex";

// 抖店可配置指标
const douyinConfigFields = [
	{
		name: '核心指标',
		type: 'core',
		fields: [
			{ key: 'exposure', label: '曝光', short: '曝光', fmt: 'bignum', width: 80, locked: true },
			{ key: 'clicks', label: '点击量', short: '点击量', fmt: 'num', width: 75, locked: true },
			{ key: 'click_rate', label: '点击率', short: '点击率', fmt: 'rate', width: 68 },
			{ key: 'add_cart', label: '加购量', short: '加购量', fmt: 'num', width: 75 },
			{ key: 'add_cart_rate', label: '加购率', short: '加购率', fmt: 'rate', width: 68 },
			{ key: 'real_orders', label: '真实订单', short: '真实订单', fmt: 'num', width: 78 },
			{ key: 'abnormal_orders', label: '异常订单', short: '异常订单', fmt: 'num', width: 78 },
			{ key: 'conversion_rate', label: '转化率', short: '转化率', fmt: 'rate', width: 68 },
			{ key: 'return_rate', label: '退货率', short: '退货率', fmt: 'rate', width: 68 },
		]
	},
	{
		name: '交易指标',
		type: 'trade',
		fields: [
			{ key: 'pay_amount', label: '用户支付金额', short: '支付金额', fmt: 'money', width: 100 },
			{ key: 'order_count', label: '成交订单数', short: '订单数', fmt: 'num', width: 80 },
			{ key: 'buyer_count', label: '成交人数', short: '成交人数', fmt: 'num', width: 85 },
			{ key: 'avg_price', label: '客单价', short: '客单价', fmt: 'money', width: 80 },
			{ key: 'refund_amount', label: '退款金额', short: '退款金额', fmt: 'money', width: 95 },
			{ key: 'refund_count', label: '退款订单数', short: '退款单数', fmt: 'num', width: 85 },
			{ key: 'stock', label: '实时可售库存', short: '可售库存', fmt: 'num', width: 85 },
		]
	},
	{
		name: '流量指标',
		type: 'traffic',
		fields: [
			{ key: 'exposure_uv', label: '商品曝光人数', short: '曝光人数', fmt: 'bignum', width: 90 },
			{ key: 'click_uv', label: '商品点击人数', short: '点击人数', fmt: 'bignum', width: 90 },
			{ key: 'exposure_click_rate', label: '曝光-点击率(人数)', short: '曝光点击率', tip: true, fmt: 'rate', width: 90 },
			{ key: 'click_deal_rate', label: '点击-成交转化率(人数)', short: '点击成交率', tip: true, fmt: 'rate', width: 90 },
		]
	}
];

// 微信小店可配置指标
const wechatConfigFields = [
	{
		name: '核心指标',
		type: 'core',
		fields: [
			{ key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', width: 90, locked: true },
			{ key: 'product_click_cnt', label: '商品点击次数', short: '点击次数', fmt: 'bignum', width: 90, locked: true },
			{ key: 'click_add_to_cart_uv', label: '加购人数', short: '加购人数', fmt: 'num', width: 85 },
			{ key: 'product_add_pay_converse_uv_ratio', label: '加购支付转化率', short: '加购转化率', fmt: 'rate', width: 90 },
			{ key: 'product_click_pay_converse_uv_rate', label: '点击成交率', short: '点击成交率', fmt: 'rate', width: 90 },
		]
	},
	{
		name: '交易指标',
		type: 'trade',
		fields: [
			{ key: 'pay_amt', label: '下单金额', short: '下单金额', fmt: 'money', width: 100 },
			{ key: 'pay_cnt', label: '下单订单数', short: '下单数', fmt: 'num', width: 80 },
			{ key: 'pay_ucnt', label: '下单人数', short: '下单人数', fmt: 'num', width: 85 },
			{ key: 'pay_jcnt', label: '下单件数', short: '下单件数', fmt: 'num', width: 85 },
			{ key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', width: 100 },
			{ key: 'net_income_amt', label: '成交金额（剔除退款）', short: '净成交额', fmt: 'money', width: 100 },
			{ key: 'net_pay_cnt', label: '成交订单数', short: '成交订单', fmt: 'num', width: 85 },
			{ key: 'net_pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', width: 85 },
			{ key: 'net_pay_pay_jcnt', label: '成交件数', short: '成交件数', fmt: 'num', width: 85 },
			{ key: 'per_user_price', label: '客单价', short: '客单价', fmt: 'money', width: 80 },
			{ key: 'product_add_pay_converse_uv_amt', label: '购物车成交金额', short: '购物车成交', fmt: 'money', width: 100 },
		]
	},
	{
		name: '退款指标',
		type: 'refund',
		fields: [
			{ key: 'pay_refund_success_amt', label: '成交退款金额', short: '成交退款', fmt: 'money', width: 95 },
			{ key: 'pay_refund_success_ucnt', label: '成交退款人数', short: '退款人数', fmt: 'num', width: 85 },
			{ key: 'pay_refund_success_ocnt', label: '成交退款订单数', short: '退款订单', fmt: 'num', width: 90 },
			{ key: 'pay_refund_success_uv_rate', label: '成交退款率', short: '退款率', fmt: 'rate', width: 75 },
			{ key: 'refund_amt', label: '退款金额', short: '退款金额', fmt: 'money', width: 95 },
			{ key: 'refund_jcnt', label: '退款件数', short: '退款件数', fmt: 'num', width: 85 },
			{ key: 'refund_cnt', label: '退款订单数', short: '退款订单', fmt: 'num', width: 90 },
			{ key: 'refund_ucnt', label: '退款人数', short: '退款人数', fmt: 'num', width: 85 },
		]
	},
	{
		name: '达人指标',
		type: 'talent',
		fields: [
			{ key: 'talent_ucnt', label: '动销达人数', short: '达人数', fmt: 'num', width: 75 },
		]
	}
];

// 可配置指标（通过指标配置弹窗控制显隐）- 保留用于兼容
const configFields = douyinConfigFields;

// 构建 key -> field 映射 - 保留用于兼容
const allConfigFieldMap = {};
configFields.forEach(g => g.fields.forEach(f => { allConfigFieldMap[f.key] = f; }));

// 抖店默认选中的可配置指标
const douyinDefaultFields = [
	'exposure', 'clicks', 'click_rate', 'add_cart', 'add_cart_rate',
	'real_orders', 'abnormal_orders', 'conversion_rate', 'return_rate',
	'pay_amount', 'order_count', 'buyer_count', 'avg_price',
	'refund_amount', 'refund_count',
	'exposure_uv', 'click_uv', 'exposure_click_rate', 'click_deal_rate',
	'stock'
];

// 微信小店默认选中的可配置指标
const wechatDefaultFields = [
	'product_click_ucnt', 'product_click_cnt', 'click_add_to_cart_uv',
	'product_add_pay_converse_uv_ratio', 'product_click_pay_converse_uv_rate',
	'pay_amt', 'pay_cnt', 'pay_ucnt', 'income_amt', 'net_income_amt',
	'net_pay_cnt', 'net_pay_ucnt', 'per_user_price',
	'pay_refund_success_amt', 'pay_refund_success_uv_rate',
	'refund_amt', 'talent_ucnt'
];

// 默认选中的可配置指标 - 保留用于兼容
const defaultSelectedFields = douyinDefaultFields;

const STORAGE_KEY_DOUYIN = 'product_board_field_config_douyin';
const STORAGE_KEY_WECHAT = 'product_board_field_config_wechat';
const STORAGE_KEY = 'product_board_field_config'; // 保留旧的键用于兼容

function createDefaultSearchData() {
	return {
		platform: 1,
		shop_id: '',
		product_id: '',
		product_name: '',
		group_id: '',
		sales_type: '全部',
		carrier_type: '全部',
		start_time: '',
		end_time: '',
		exposure_range: '',
		click_range: '',
		click_rate_range: '',
		cart_rate_range: '',
		cart_count_range: '',
		conversion_rate_range: '',
		real_order_range: '',
		abnormal_order_range: '',
		return_rate_range: '',
		wechat_click_cnt_range: '',
		wechat_click_ucnt_range: '',
		wechat_add_cart_uv_range: '',
		wechat_pay_cnt_range: '',
		wechat_net_pay_cnt_range: '',
		wechat_refund_cnt_range: '',
		wechat_click_pay_rate_range: '',
		wechat_refund_rate_range: '',
	};
}

function createDefaultRangeCustom() {
	return {
		exposure_min: '',
		exposure_max: '',
		click_min: '',
		click_max: '',
		click_rate_min: '',
		click_rate_max: '',
		cart_rate_min: '',
		cart_rate_max: '',
		cart_count_min: '',
		cart_count_max: '',
		conversion_rate_min: '',
		conversion_rate_max: '',
		real_order_min: '',
		real_order_max: '',
		abnormal_order_min: '',
		abnormal_order_max: '',
		return_rate_min: '',
		return_rate_max: '',
		wechat_click_cnt_min: '',
		wechat_click_cnt_max: '',
		wechat_click_ucnt_min: '',
		wechat_click_ucnt_max: '',
		wechat_add_cart_uv_min: '',
		wechat_add_cart_uv_max: '',
		wechat_pay_cnt_min: '',
		wechat_pay_cnt_max: '',
		wechat_net_pay_cnt_min: '',
		wechat_net_pay_cnt_max: '',
		wechat_refund_cnt_min: '',
		wechat_refund_cnt_max: '',
		wechat_click_pay_rate_min: '',
		wechat_click_pay_rate_max: '',
		wechat_refund_rate_min: '',
		wechat_refund_rate_max: '',
	};
}

export default {
	name: "ucProductBoard",
	data() {
		return {
			loading: false,
			showRangeFilters: false,
			showWechatRangeFilters: false,
			searchData: createDefaultSearchData(),
			rangeCustom: createDefaultRangeCustom(),
			exposureRangeOptions: [
				{ label: '0-1000', value: '0-1000' },
				{ label: '1000-3000', value: '1000-3000' },
				{ label: '3000-5000', value: '3000-5000' },
				{ label: '5000-10000', value: '5000-10000' },
				{ label: '10000以上', value: '10000+' },
				{ label: '自定义', value: 'custom' },
			],
			clickRangeOptions: [
				{ label: '0-10', value: '0-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-200', value: '100-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			clickRateRangeOptions: [
				{ label: '0-1%', value: '0-1%' },
				{ label: '1%-2%', value: '1%-2%' },
				{ label: '2%-4%', value: '2%-4%' },
				{ label: '4%-6%', value: '4%-6%' },
				{ label: '6%以上', value: '6%+' },
				{ label: '自定义', value: 'custom' },
			],
			cartRateRangeOptions: [
				{ label: '0-5%', value: '0-5%' },
				{ label: '5%-8%', value: '5%-8%' },
				{ label: '8%-10%', value: '8%-10%' },
				{ label: '10%-15%', value: '10%-15%' },
				{ label: '15%以上', value: '15%+' },
				{ label: '自定义', value: 'custom' },
			],
			realOrderRangeOptions: [
				{ label: '0-5', value: '0-5' },
				{ label: '5-10', value: '5-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-200', value: '50-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			abnormalOrderRangeOptions: [
				{ label: '0-5', value: '0-5' },
				{ label: '5-10', value: '5-10' },
				{ label: '10-20', value: '10-20' },
				{ label: '20-50', value: '20-50' },
				{ label: '50以上', value: '50+' },
				{ label: '自定义', value: 'custom' },
			],
			cartCountRangeOptions: [
				{ label: '0-10', value: '0-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-200', value: '100-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			conversionRateRangeOptions: [
				{ label: '0-1%', value: '0-1%' },
				{ label: '1%-2%', value: '1%-2%' },
				{ label: '2%-4%', value: '2%-4%' },
				{ label: '5%-6%', value: '5%-6%' },
				{ label: '6%以上', value: '6%+' },
				{ label: '自定义', value: 'custom' },
			],
			returnRateRangeOptions: [
				{ label: '0-10%', value: '0-10%' },
				{ label: '10%-20%', value: '10%-20%' },
				{ label: '20%-30%', value: '20%-30%' },
				{ label: '30%-50%', value: '30%-50%' },
				{ label: '50%以上', value: '50%+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatClickCntRangeOptions: [
				{ label: '0-100', value: '0-100' },
				{ label: '100-500', value: '100-500' },
				{ label: '500-1000', value: '500-1000' },
				{ label: '1000-5000', value: '1000-5000' },
				{ label: '5000以上', value: '5000+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatClickUcntRangeOptions: [
				{ label: '0-50', value: '0-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-500', value: '100-500' },
				{ label: '500-1000', value: '500-1000' },
				{ label: '1000以上', value: '1000+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatAddCartUvRangeOptions: [
				{ label: '0-10', value: '0-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-200', value: '100-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatPayCntRangeOptions: [
				{ label: '0-10', value: '0-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-200', value: '100-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatNetPayCntRangeOptions: [
				{ label: '0-10', value: '0-10' },
				{ label: '10-50', value: '10-50' },
				{ label: '50-100', value: '50-100' },
				{ label: '100-200', value: '100-200' },
				{ label: '200以上', value: '200+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatRefundCntRangeOptions: [
				{ label: '0-5', value: '0-5' },
				{ label: '5-10', value: '5-10' },
				{ label: '10-20', value: '10-20' },
				{ label: '20-50', value: '20-50' },
				{ label: '50以上', value: '50+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatClickPayRateRangeOptions: [
				{ label: '0-1%', value: '0-1%' },
				{ label: '1%-3%', value: '1%-3%' },
				{ label: '3%-5%', value: '3%-5%' },
				{ label: '5%-10%', value: '5%-10%' },
				{ label: '10%以上', value: '10%+' },
				{ label: '自定义', value: 'custom' },
			],
			wechatRefundRateRangeOptions: [
				{ label: '0-10%', value: '0-10%' },
				{ label: '10%-20%', value: '10%-20%' },
				{ label: '20%-30%', value: '20%-30%' },
				{ label: '30%-50%', value: '30%-50%' },
				{ label: '50%以上', value: '50%+' },
				{ label: '自定义', value: 'custom' },
			],
			platformOptions: [
				{ value: 1, label: '抖店' },
				{ value: 7, label: '微信小店' },
			],
			shopOptions: [],
			groupList: [],
			groupLoading: false,
			groupListHasCount: false,
			groupManageVisible: false,
			groupFormVisible: false,
			groupFormEdit: false,
			groupFormLoading: false,
			groupForm: { id: null, name: '', sort: 0 },
			selectedRows: [],
			batchGroupVisible: false,
			batchGroupId: '',
			batchGroupRows: [],
			batchGroupLoading: false,
			hideLeftColumns: false,
			salesTypeOptions: [
				{ value: '全部', label: '全部' },
				{ value: '自营', label: '自营' },
				{ value: '合作', label: '合作' },
			],
			carrierTypeOptions: [
				{ value: '全部', label: '全部' },
				{ value: '直播', label: '直播' },
				{ value: '短视频', label: '短视频' },
				{ value: '商品卡', label: '商品卡' },
				{ value: '图文', label: '图文' },
			],
			timeOptions: [
				// { id: 1, name: '实时', day: 'realtime' },  // 隐藏实时选项
				{ id: 2, name: '近1天', day: '1' },
				{ id: 3, name: '近7天', day: '7' },
				{ id: 4, name: '近30天', day: '30' },
			],
			datePickerOptions: {
				disabledDate(time) {
					// 禁用未来日期
					if (time.getTime() > Date.now()) {
						return true;
					}
					return false;
				},
				onPick: ({ maxDate, minDate }) => {
					if (minDate && !maxDate) {
						// 选择了开始日期，限制结束日期在31天内
						const maxTime = minDate.getTime() + 31 * 24 * 60 * 60 * 1000;
						const minTime = minDate.getTime() - 31 * 24 * 60 * 60 * 1000;
						return {
							disabledDate(time) {
								const t = time.getTime();
								return t > maxTime || t < minTime || t > Date.now();
							}
						};
					}
				}
			},
			timeSelectId: 2,  // 默认选中"近1天"
			customDateRange: '',
			page_data: {
				page: 1,
				limit: 10,
				total: 0
			},
			tableData: [],
			douyinSelectedFields: [...douyinDefaultFields],
			wechatSelectedFields: [...wechatDefaultFields],
			tempSelectedFields: [],
			showFieldConfig: false,
		}
	},
	components: {
		Pagination,
		myHead, myFoot, ucMenu
	},
	computed: {
		...mapState({
			userinfo: (state) => state.login.userinfo,
		}),
		// 根据当前平台返回对应的字段配置
		configFields() {
			return this.searchData.platform === 7 ? wechatConfigFields : douyinConfigFields;
		},
		// 根据当前平台返回对应的选中字段
		selectedFields() {
			return this.searchData.platform === 7 ? this.wechatSelectedFields : this.douyinSelectedFields;
		},
		// 当前选中的可配置指标列表（保持选中顺序）
		activeFields() {
			const allFieldMap = {};
			this.configFields.forEach(g => g.fields.forEach(f => { allFieldMap[f.key] = f; }));
			return this.selectedFields
				.map(key => allFieldMap[key])
				.filter(f => !!f);
		},
		selectedProductIds() {
			return Array.from(new Set(this.batchGroupRows.map(item => String(item.product_id)).filter(Boolean)));
		}
	},
	created() {
		// 初始化默认时间范围（近1天）
		this.initDefaultDateRange();
		this.searchData.platform = this.normalizePlatform(this.searchData.platform);
		this.loadShopList();
		this.loadGroupList();
		this.loadFieldConfig();
		this.loadData();
	},
	methods: {
		...mapActions({
			getProductBoardList: "shop_board/getProductBoardList",
			saveProductFieldConfig: "shop_board/saveProductFieldConfig",
			getShopList: "shop_board/getShopList",
			getProductBoardGroupList: "shop_board/getProductBoardGroupList",
			opProductBoardGroupCreate: "shop_board/opProductBoardGroupCreate",
			opProductBoardGroupUpdate: "shop_board/opProductBoardGroupUpdate",
			opProductBoardGroupDelete: "shop_board/opProductBoardGroupDelete",
			opProductBoardBatchSetGroup: "shop_board/opProductBoardBatchSetGroup",
		}),
		loadGroupList(options = {}) {
			const { withCount = false, force = false } = options;
			if (this.groupLoading) return;
			if (!force && this.groupList.length > 0 && (!withCount || this.groupListHasCount)) return;
			this.groupLoading = true;
			this.getProductBoardGroupList({
				data: { with_count: withCount ? 1 : 0 },
				success: (res) => {
					this.groupLoading = false;
					if (res.code === 200) {
						this.groupList = res.data || [];
						this.groupListHasCount = withCount;
						if (this.searchData.group_id && !this.groupList.find(item => item.id === this.searchData.group_id)) {
							this.searchData.group_id = '';
						}
					} else {
						this.$message.error(res.message || '获取分组失败');
					}
				}
			});
		},
		openGroupManageDialog() {
			this.groupManageVisible = true;
			this.loadGroupList({ withCount: true, force: true });
		},
		handleAddGroup() {
			this.groupForm = { id: null, name: '', sort: 0 };
			this.groupFormEdit = false;
			this.groupFormVisible = true;
		},
		handleEditGroup(row) {
			this.groupForm = { id: row.id, name: row.name, sort: row.sort || 0 };
			this.groupFormEdit = true;
			this.groupFormVisible = true;
		},
		submitGroupForm() {
			if (!this.groupForm.name || !this.groupForm.name.trim()) {
				this.$message.warning('请输入分组名称');
				return;
			}
			this.groupFormLoading = true;
			const data = {
				name: this.groupForm.name.trim(),
				sort: this.groupForm.sort || 0,
			};
			const callback = (res, successMessage) => {
				this.groupFormLoading = false;
				if (res.code === 200) {
					this.$message.success(successMessage);
					this.groupFormVisible = false;
					this.loadGroupList({ withCount: true, force: true });
				} else {
					this.$message.error(res.message || '操作失败');
				}
			};
			if (this.groupFormEdit) {
				this.opProductBoardGroupUpdate({
					id: this.groupForm.id,
					data,
					success: (res) => callback(res, '修改成功')
				});
				return;
			}
			this.opProductBoardGroupCreate({
				data,
				success: (res) => callback(res, '新增成功')
			});
		},
		handleDeleteGroup(row) {
			this.$confirm(`确定删除分组「${row.name}」吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.opProductBoardGroupDelete({
					id: row.id,
					success: (res) => {
						if (res.code === 200) {
							this.$message.success('删除成功');
							this.loadGroupList({ withCount: true, force: true });
							this.loadData();
						} else {
							this.$message.error(res.message || '删除失败');
						}
					}
				});
			}).catch(() => {});
		},
		handleSelectionChange(rows) {
			this.selectedRows = rows || [];
		},
		toggleLeftColumns(hidden) {
			this.hideLeftColumns = hidden;
		},
		openBatchGroupDialog(rows) {
			const targetRows = Array.isArray(rows) && rows.length > 0 ? rows : this.selectedRows;
			if (!targetRows || targetRows.length === 0) {
				this.$message.warning('请先选择商品');
				return;
			}
			this.batchGroupRows = targetRows;
			this.batchGroupId = targetRows.length === 1 && targetRows[0].group_id ? targetRows[0].group_id : '';
			this.batchGroupVisible = true;
			this.loadGroupList({ withCount: false, force: this.groupList.length === 0 });
		},
		submitBatchSetGroup() {
			if (this.batchGroupId === '' || this.batchGroupId === null) {
				this.$message.warning('请选择分组');
				return;
			}
			if (this.selectedProductIds.length === 0) {
				this.$message.warning('未找到可设置的商品');
				return;
			}
			this.batchGroupLoading = true;
			const isRemoveGroup = this.batchGroupId === 0;
			this.opProductBoardBatchSetGroup({
				data: {
					product_ids: this.selectedProductIds,
					group_id: isRemoveGroup ? null : this.batchGroupId,
				},
				success: (res) => {
					this.batchGroupLoading = false;
					if (res.code === 200) {
						this.$message.success(isRemoveGroup ? '已移出分组' : '设置成功');
						this.batchGroupVisible = false;
						this.batchGroupRows = [];
						this.selectedRows = [];
						this.loadGroupList({ withCount: this.groupManageVisible, force: true });
						this.loadData();
					} else {
						this.$message.error(res.message || '设置失败');
					}
				}
			});
		},
		// 加载字段配置
		loadFieldConfig() {
			// 加载抖店配置
			let douyinSaved = localStorage.getItem(STORAGE_KEY_DOUYIN);
			if (douyinSaved) {
				try {
					this.douyinSelectedFields = JSON.parse(douyinSaved);
				} catch (e) {
					this.douyinSelectedFields = [...douyinDefaultFields];
				}
			} else {
				this.douyinSelectedFields = [...douyinDefaultFields];
			}

			// 加载微信配置
			let wechatSaved = localStorage.getItem(STORAGE_KEY_WECHAT);
			if (wechatSaved) {
				try {
					this.wechatSelectedFields = JSON.parse(wechatSaved);
				} catch (e) {
					this.wechatSelectedFields = [...wechatDefaultFields];
				}
			} else {
				this.wechatSelectedFields = [...wechatDefaultFields];
			}

			// 初始化临时选择
			this.tempSelectedFields = [...this.selectedFields];
		},
		// 打开字段配置弹窗
		openFieldConfig() {
			this.tempSelectedFields = [...this.selectedFields];
			console.log('商品看板-打开配置弹窗, tempSelectedFields:', this.tempSelectedFields);
			console.log('当前平台:', this.searchData.platform);
			this.showFieldConfig = true;
		},
		// 确认字段配置
		confirmFieldConfig() {
			console.log('商品看板-确认配置, tempSelectedFields:', this.tempSelectedFields);
			// 根据当前平台保存到对应的配置
			if (this.searchData.platform === 7) {
				this.wechatSelectedFields = [...this.tempSelectedFields];
				localStorage.setItem(STORAGE_KEY_WECHAT, JSON.stringify(this.wechatSelectedFields));
				console.log('保存微信配置:', this.wechatSelectedFields);
			} else {
				this.douyinSelectedFields = [...this.tempSelectedFields];
				localStorage.setItem(STORAGE_KEY_DOUYIN, JSON.stringify(this.douyinSelectedFields));
				console.log('保存抖店配置:', this.douyinSelectedFields);
			}
			this.showFieldConfig = false;
			this.$nextTick(() => {
				console.log('配置已更新, activeFields:', this.activeFields);
			});
		},
		// 配置弹窗关闭时
		onConfigClose() {
			// 恢复临时选择为当前平台的配置
			this.tempSelectedFields = [...this.selectedFields];
		},
		// 表头样式
		headerCellStyle() {
			return { color: '#454545', 'font-weight': 'bold', 'font-size': '12px', background: '#eef1f6' };
		},
		// 平台 Tab 切换
		handlePlatformTab(platform) {
			const normalizedPlatform = this.normalizePlatform(platform);
			if (this.searchData.platform === normalizedPlatform) return;
			this.searchData.platform = normalizedPlatform;
			// 清空店铺筛选
			this.searchData.shop_id = '';
			// 更新临时选择为当前平台的配置
			this.tempSelectedFields = [...this.selectedFields];
			this.selectedRows = [];
			this.batchGroupRows = [];
			// 重新加载店铺列表（带平台参数）
			this.loadShopList();
			// 重新加载数据
			this.handleSearch();
		},
		// 行样式：不同平台行用微妙底色区分
		tableRowClass({ row }) {
			if (row.platform === '微信小店') return 'row-wechat';
			return '';
		},
		// 平台标签样式
		platformClass(platform) {
			if (platform === 1 || platform === '1') return 'douyin';
			if (platform === 7 || platform === '7') return 'wechat';
			return '';
		},
		// 平台名称映射
		platformName(platform) {
			const platformMap = {
				1: '抖店',
				'1': '抖店',
				7: '微信小店',
				'7': '微信小店',
			};
			return platformMap[platform] || platform;
		},
		normalizePlatform(platform) {
			const normalizedPlatform = Number(platform);
			if (normalizedPlatform === 7) return 7;
			return 1;
		},
		// 产品类型标签样式
		typeClass(type) {
			const map = {
				'护肤': 'skincare', '面膜': 'skincare', '服装': 'clothing',
				'家居': 'home', '数码': 'digital', '食品': 'food',
				'母婴': 'baby', '运动': 'sport', '宠物': 'pet',
			};
			return map[type] || '';
		},
		// 数值格式化
		formatNum(val) {
			if (val === undefined || val === null) return '--';
			let n = Number(val);
			if (isNaN(n)) return val;
			if (n >= 10000) return (n / 10000).toFixed(1) + '万';
			return n.toLocaleString('zh-CN');
		},
		// 通用比率样式（mid阈值, good阈值）
		rateClass(val, midThreshold, goodThreshold) {
			let n = parseFloat(val);
			if (isNaN(n)) return 'cell_rate';
			if (n >= goodThreshold) return 'cell_rate cell_rate_good';
			if (n >= midThreshold) return 'cell_rate';
			return 'cell_rate cell_rate_low';
		},
		// 退货率样式
		returnRateClass(val) {
			let n = parseFloat(val);
			if (isNaN(n)) return 'cell_rate';
			if (n >= 10) return 'cell_rate cell_rate_high';
			if (n >= 5) return 'cell_rate cell_rate_mid';
			return 'cell_rate';
		},
		// 可配置列格式化
		formatCell(col, val) {
			if (val === undefined || val === null || val === '') return '--';

			// 处理特殊字段
			if (col.key === 'abnormal_orders') {
				return val;
			}

			if (col.fmt === 'money') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return '¥' + (n / 10000).toFixed(2) + '万';
				return '¥' + n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
			}
			if (col.fmt === 'num') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(2) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (col.fmt === 'bignum') {
				let n = Number(val);
				if (isNaN(n)) return val;
				if (n >= 10000) return (n / 10000).toFixed(1) + '万';
				return n.toLocaleString('zh-CN');
			}
			if (col.fmt === 'rate') {
				// 如果值已经包含%，直接返回
				if (typeof val === 'string' && val.includes('%')) return val;
				return String(val);
			}
			return val;
		},
		// 可配置列样式
		cellClass(col, val) {
			// 异常订单特殊样式
			if (col.key === 'abnormal_orders') {
				let n = Number(val);
				if (isNaN(n) || n === 0) return 'num_zero';
				return 'abnormal_val';
			}

			// 数值类型
			if (col.fmt === 'num' || col.fmt === 'bignum') {
				return 'num_text';
			}

			// 比率类型
			if (col.fmt === 'rate') {
				// 解析百分比值
				let numVal = val;
				if (typeof val === 'string') {
					numVal = parseFloat(val.replace('%', ''));
				} else {
					numVal = parseFloat(val);
				}

				if (isNaN(numVal)) return 'cell_rate';

				// 不同指标的阈值不同
				if (col.key === 'click_rate') {
					if (numVal >= 20) return 'cell_rate cell_rate_good';
					if (numVal >= 15) return 'cell_rate';
					return 'cell_rate cell_rate_low';
				}
				if (col.key === 'add_cart_rate') {
					if (numVal >= 35) return 'cell_rate cell_rate_good';
					if (numVal >= 25) return 'cell_rate';
					return 'cell_rate cell_rate_low';
				}
				if (col.key === 'conversion_rate') {
					if (numVal >= 8) return 'cell_rate cell_rate_good';
					if (numVal >= 5) return 'cell_rate';
					return 'cell_rate cell_rate_low';
				}
				if (col.key === 'return_rate') {
					if (numVal >= 10) return 'cell_rate cell_rate_high';
					if (numVal >= 5) return 'cell_rate cell_rate_mid';
					return 'cell_rate';
				}

				// 其他比率字段的通用阈值
				if (numVal >= 10) return 'cell_rate cell_rate_high';
				if (numVal >= 5) return 'cell_rate cell_rate_mid';
				return 'cell_rate';
			}
			return '';
		},
		getGroupCheckedCount(group) {
			return group.fields.filter(f => this.tempSelectedFields.includes(f.key)).length;
		},
		isGroupAllChecked(group) {
			return group.fields.every(f => this.tempSelectedFields.includes(f.key));
		},
		isGroupIndeterminate(group) {
			let count = this.getGroupCheckedCount(group);
			return count > 0 && count < group.fields.length;
		},
		toggleGroupAll(group, checked) {
			let lockedKeys = group.fields.filter(f => f.locked).map(f => f.key);
			let keys = group.fields.map(f => f.key);
			if (checked) {
				let set = new Set(this.tempSelectedFields);
				keys.forEach(k => set.add(k));
				this.tempSelectedFields = [...set];
			} else {
				this.tempSelectedFields = this.tempSelectedFields.filter(k => !keys.includes(k) || lockedKeys.includes(k));
			}
		},
		// 初始化默认日期范围（近1天）
		initDefaultDateRange() {
			const today = new Date();
			const yesterday = new Date(today);
			yesterday.setDate(yesterday.getDate() - 1);
			const end = this.formatDate(yesterday);
			const start = this.formatDate(yesterday);
			this.customDateRange = [start, end];
		},
		// 时间标签点击
		timeTagClick(item) {
			this.timeSelectId = item.id;
			this.searchData.start_time = '';
			this.searchData.end_time = '';

			// 根据选择的时间类型设置日期选择器的值
			const today = new Date();
			if (item.day === 'realtime') {
				// 实时：今天
				const todayStr = this.formatDate(today);
				this.customDateRange = [todayStr, todayStr];
			} else {
				// 近N天：昨天往前推N-1天到昨天
				const days = parseInt(item.day);
				const yesterday = new Date(today);
				yesterday.setDate(yesterday.getDate() - 1);
				const end = this.formatDate(yesterday);
				const start = new Date(yesterday.getTime()); // 创建新的 Date 对象
				start.setDate(start.getDate() - (days - 1));
				const startStr = this.formatDate(start);
				this.customDateRange = [startStr, end];
			}

			this.loadData();
		},
		customDateChange() {
			if (this.customDateRange && this.customDateRange.length === 2) {
				const start = new Date(this.customDateRange[0]);
				const end = new Date(this.customDateRange[1]);
				const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

				if (diffDays > 31) {
					this.$message.warning('时间范围不能超过31天');
					this.customDateRange = '';
					return;
				}

				this.timeSelectId = '';
				this.searchData.start_time = this.customDateRange[0];
				this.searchData.end_time = this.customDateRange[1];
			} else {
				this.timeSelectId = 2;  // 清空时恢复为"近1天"
				this.searchData.start_time = '';
				this.searchData.end_time = '';
			}
			this.loadData();
		},
		handleSearch() {
			this.page_data.page = 1;
			this.loadData();
		},
		handleReset() {
			this.searchData = createDefaultSearchData();
			this.searchData.platform = this.normalizePlatform(this.searchData.platform);
			this.rangeCustom = createDefaultRangeCustom();
			this.showRangeFilters = false;
			this.showWechatRangeFilters = false;
			this.selectedRows = [];
			this.batchGroupRows = [];
			this.timeSelectId = 2;  // 重置为"近1天"
			this.initDefaultDateRange();  // 重置日期范围显示
			this.page_data.page = 1;
			this.loadShopList();
			this.loadData();
		},
		// 加载店铺列表
		loadShopList() {
			const platform = this.normalizePlatform(this.searchData.platform);
			this.searchData.platform = platform;
			const params = {
				shop_type: platform,
			};
      params.status=1
			this.getShopList({
				data: params,
				success: (res) => {
					if (res.code === 200 && res.data) {
						// 数据结构是 data.list.list
						if (res.data.list && res.data.list.list) {
							this.shopOptions = res.data.list.list;
						} else if (Array.isArray(res.data.list)) {
							this.shopOptions = res.data.list;
						} else if (Array.isArray(res.data)) {
							this.shopOptions = res.data;
						} else {
							this.shopOptions = [];
						}
					}
				}
			});
		},
		// 加载数据
		loadData() {
			this.loading = true;
			const platform = this.normalizePlatform(this.searchData.platform);
			this.searchData.platform = platform;

			// 构建请求参数
			let params = {
				page: this.page_data.page,
				limit: this.page_data.limit,
				platform,
			};

			// 店铺筛选
			if (this.searchData.shop_id) {
				params.mer_shop_id = this.searchData.shop_id;
			}

			// 商品ID筛选
			if (this.searchData.product_id) {
				params.product_id = this.searchData.product_id;
			}

			// 商品名称筛选
			if (this.searchData.product_name) {
				params.product_name = this.searchData.product_name;
			}

			if (this.searchData.group_id !== '' && this.searchData.group_id !== null) {
				params.group_id = this.searchData.group_id;
			}

			// 售卖类型筛选
			if (this.searchData.sales_type) {
				params.sales_type = this.searchData.sales_type;
			}

			// 载体类型筛选
			if (this.searchData.carrier_type) {
				params.carrier_type = this.searchData.carrier_type;
			}

			// 时间参数
			if (this.searchData.start_time && this.searchData.end_time) {
				params.start_date = this.searchData.start_time;
				params.end_date = this.searchData.end_time;
			} else {
				// 根据时间类型计算日期范围
				const today = new Date();
				const endDate = this.formatDate(today);
				let startDate = endDate;

				if (this.timeSelectId) {
					const timeOption = this.timeOptions.find(t => t.id === this.timeSelectId);
					if (timeOption && timeOption.day !== 'realtime') {
						const days = parseInt(timeOption.day);
						const yesterday = new Date(today);
						yesterday.setDate(yesterday.getDate() - 1);
						const end = this.formatDate(yesterday);
						const start = new Date(yesterday);
						start.setDate(start.getDate() - (days - 1));
						startDate = this.formatDate(start);
						params.start_date = startDate;
						params.end_date = end;
					} else {
						params.start_date = endDate;
						params.end_date = endDate;
					}
				} else {
					params.start_date = endDate;
					params.end_date = endDate;
				}
			}

			// 区间筛选参数（仅抖店）
			if (this.searchData.platform !== 7) {
				const expRange = this.buildRangeParam('exposure', false);
				if (expRange) params.exposure_range = expRange;
				const clkRange = this.buildRangeParam('click', false);
				if (clkRange) params.click_range = clkRange;
				const clkRateRange = this.buildRangeParam('click_rate', true);
				if (clkRateRange) params.click_rate_range = clkRateRange;
				const cartRateRange = this.buildRangeParam('cart_rate', true);
				if (cartRateRange) params.cart_rate_range = cartRateRange;
				const cartCountRange = this.buildRangeParam('cart_count', false);
				if (cartCountRange) params.cart_count_range = cartCountRange;
				const conversionRateRange = this.buildRangeParam('conversion_rate', true);
				if (conversionRateRange) params.conversion_rate_range = conversionRateRange;
				const realOrderRange = this.buildRangeParam('real_order', false);
				if (realOrderRange) params.real_order_range = realOrderRange;
				const abnormalRange = this.buildRangeParam('abnormal_order', false);
				if (abnormalRange) params.abnormal_order_range = abnormalRange;
				const returnRateRange = this.buildRangeParam('return_rate', true);
				if (returnRateRange) params.return_rate_range = returnRateRange;
			}

			// 区间筛选参数（仅微信）
			if (this.searchData.platform === 7) {
				const wechatClickCntRange = this.buildRangeParam('wechat_click_cnt', false);
				if (wechatClickCntRange) params.wechat_click_cnt_range = wechatClickCntRange;
				const wechatClickUcntRange = this.buildRangeParam('wechat_click_ucnt', false);
				if (wechatClickUcntRange) params.wechat_click_ucnt_range = wechatClickUcntRange;
				const wechatAddCartUvRange = this.buildRangeParam('wechat_add_cart_uv', false);
				if (wechatAddCartUvRange) params.wechat_add_cart_uv_range = wechatAddCartUvRange;
				const wechatPayCntRange = this.buildRangeParam('wechat_pay_cnt', false);
				if (wechatPayCntRange) params.wechat_pay_cnt_range = wechatPayCntRange;
				const wechatNetPayCntRange = this.buildRangeParam('wechat_net_pay_cnt', false);
				if (wechatNetPayCntRange) params.wechat_net_pay_cnt_range = wechatNetPayCntRange;
				const wechatRefundCntRange = this.buildRangeParam('wechat_refund_cnt', false);
				if (wechatRefundCntRange) params.wechat_refund_cnt_range = wechatRefundCntRange;
				const wechatClickPayRateRange = this.buildRangeParam('wechat_click_pay_rate', true);
				if (wechatClickPayRateRange) params.wechat_click_pay_rate_range = wechatClickPayRateRange;
				const wechatRefundRateRange = this.buildRangeParam('wechat_refund_rate', true);
				if (wechatRefundRateRange) params.wechat_refund_rate_range = wechatRefundRateRange;
			}

			this.getProductBoardList({
				data: params,
				success: (res) => {
					this.loading = false;
					if (res.code === 200 && res.data) {
						// 接口返回的数据结构
						if (Array.isArray(res.data)) {
							this.tableData = res.data;
							this.page_data.total = res.data.length;
						} else if (res.data.list) {
							this.tableData = res.data.list || [];
							this.page_data.total = res.data.total || 0;
						} else {
							this.tableData = [];
							this.page_data.total = 0;
						}
					} else {
						this.$message.error(res.msg || res.message || '获取数据失败');
						this.tableData = [];
						this.page_data.total = 0;
					}
				}
			});
		},
		// 格式化日期为 yyyy-MM-dd
		formatDate(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		// 区间筛选变化处理
		handleRangeChange(field) {
			const rangeValue = this.searchData[`${field}_range`];
			if (rangeValue !== 'custom') {
				// 清空自定义输入
				this.rangeCustom[`${field}_min`] = '';
				this.rangeCustom[`${field}_max`] = '';
			}
		},
		// 构建区间参数
		buildRangeParam(field, isPercentage = false) {
			const rangeValue = this.searchData[`${field}_range`];
			if (rangeValue === 'custom') {
				const min = this.rangeCustom[`${field}_min`];
				const max = this.rangeCustom[`${field}_max`];
				if (!min && !max) return '';
				if (min && !max) return isPercentage ? `${min}%+` : `${min}+`;
				if (min && max) return isPercentage ? `${min}%-${max}%` : `${min}-${max}`;
				if (!min && max) return isPercentage ? `0-${max}%` : `0-${max}`;
			}
			return rangeValue || '';
		},
	}
}
</script>

<style scoped>

.center{display: flex;flex: 1;}

.el-card__body{padding:12px 20px;}

/* 标题 */
.board_title{margin-bottom: 12px;display:flex;align-items:center;justify-content:space-between;gap:12px;}
.board_title h3{font-size: 16px;color: #303133;font-weight: 600;margin: 0;line-height: 1;}
.board_title_actions{display:flex;align-items:center;gap:8px;}

/* 筛选区域 */
.filter_wrap{padding-bottom: 10px;border-bottom: 1px solid #eee;}

/* 平台类型 Tab */
.platform_tabs_wrap{display: flex;align-items: center;gap: 12px;margin-bottom: 15px;padding: 16px 0;border-bottom: 1px solid #f0f0f0;}
.platform_tab{padding: 10px 28px;border-radius: 20px;cursor: pointer;font-size: 15px;color: #666;background: #f5f5f5;border: 1px solid #e0e0e0;transition: all 0.2s ease;}
.platform_tab:hover{background: #fff0ef;border-color: #ffccc7;color: #f0413e;}
.platform_tab.active{font-weight: bold;color: #fff;background: linear-gradient(135deg, #f0413e, #ff6b5a);border-color: transparent;box-shadow: 0 2px 8px rgba(240,65,62,0.3);}

.filter_row{display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;}
.filter_row:last-child{margin-bottom: 0;}
.filter_item{display: flex;align-items: center;margin-right: 15px;margin-bottom: 5px;}
.filter_label{font-size: 13px;color: #606266;white-space: nowrap;}
.filter_btns{margin-left: auto;display: flex;align-items: center;}
.selected_hint{font-size:12px;color:#909399;margin-right:10px;}

/* 时间快捷标签 */
.time_tag{display: inline-block;padding: 4px 10px;font-size: 13px;color: #737E97;cursor: pointer;border-radius: 4px;margin-right: 4px;transition: all 0.2s;}
.time_tag:hover{color: #409EFF;}
.time_tag.active{color: #fff;background: #409EFF;}
.time_tag_more i{font-size: 12px;margin-left: 2px;transition: transform 0.2s;}
.time_tag_more i.rotate{transform: rotate(180deg);}

/* 店铺名称单元格 */
.shop_name_cell{display: flex;flex-direction: column;align-items: flex-start;gap: 4px;}
.shop_name{font-size: 14px;font-weight: 600;color: #303133;line-height: 1.4;}

/* 平台标签 - 小型版本（放在店铺名称下方）*/
.platform_tag_small{display: inline-block;padding: 1px 6px;border-radius: 2px;font-size: 11px;font-weight: 500;line-height: 1.4;}
.platform_tag_small.douyin{background: #fff0f0;color: #e4393c;}
.platform_tag_small.wechat{background: #e9f7ef;color: #07c160;}

/* 平台标签 - 原始版本（保留用于其他地方）*/
.platform_tag{display: inline-block;padding: 1px 6px;border-radius: 3px;font-size: 12px;font-weight: 600;}
.platform_tag.douyin{background: #fff0f0;color: #e4393c;}
.platform_tag.wechat{background: #e9f7ef;color: #07c160;}

/* ID文字 */
.id_text{font-size: 12px;color: #909399;font-family: 'Monaco', 'Menlo', monospace;}
.id_cell{display:flex;flex-direction:column;align-items:center;gap:4px;}
.id_group_tag{max-width:100%;padding:2px 8px;border:1px solid #dcdfe6;border-radius:10px;background:#f7f8fa;font-size:12px;line-height:1.3;color:#606266;word-break:break-all;text-align:center;}

/* 标题文字 */
.title_text{font-size: 13px;color: #303133;}
.group_empty{font-size:12px;color:#c0c4cc;}
.group_empty_tag{padding:2px 8px;border:1px dashed #e4e7ed;border-radius:10px;background:#fafafa;}
.column_header_with_action{display:flex;align-items:center;justify-content:space-between;gap:6px;}

/* 产品类型标签 */
.type_tag{display: inline-block;padding: 1px 6px;border-radius: 3px;font-size: 12px;}
.type_tag.skincare{background: #fdf2f8;color: #d63384;}
.type_tag.clothing{background: #eff6ff;color: #3b82f6;}
.type_tag.home{background: #fef9e7;color: #b7791f;}
.type_tag.digital{background: #f0f4ff;color: #4f46e5;}
.type_tag.food{background: #fef3e2;color: #d97706;}
.type_tag.baby{background: #fce7f3;color: #db2777;}
.type_tag.sport{background: #ecfdf5;color: #059669;}
.type_tag.pet{background: #f5f3ff;color: #7c3aed;}

/* 数值 */
.num_text{font-size: 13px;color: #303133;font-variant-numeric: tabular-nums;}
.num_zero{font-size: 13px;color: #c0c4cc;}
.abnormal_val{font-size: 13px;color: #F56C6C;font-weight: 600;}

/* 比率单元格 */
.cell_rate{font-size: 13px;color: #606266;font-variant-numeric: tabular-nums;}
.cell_rate_good{color: #27ae60;font-weight: 600;}
.cell_rate_low{color: #c0c4cc;}
.cell_rate_mid{color: #e6a23c;font-weight: 500;}
.cell_rate_high{color: #f56c6c;font-weight: 600;}

/* 多平台行底色微区分 */
:deep(.row-wechat){background: rgba(233,247,239,0.15);}
:deep(.row-wechat:hover > td){background: rgba(233,247,239,0.3);}

/* 表头精简列名 */
.col_header{font-size: 12px;white-space: nowrap;}

/* 可配置指标列底色 */
:deep(.col-config){background: rgba(245,247,250,0.5) !important;}

/* 分页 */
.turn_page{display: flex;justify-content: flex-end;margin-top: 10px;}

/* 指标配置弹窗 */
.field_config_body{max-height: 450px;overflow-y: auto;}
.field_group{margin-bottom: 20px;}
.field_group:last-child{margin-bottom: 0;}
.group_title{font-weight: bold;font-size: 14px;color: #303133;margin-bottom: 10px;padding-bottom: 6px;border-bottom: 1px solid #EBEEF5;display: flex;align-items: center;justify-content: space-between;}
.group_count{font-weight: normal;font-size: 12px;color: #909399;}
.field_group .el-checkbox{width: 240px;margin-right: 10px;margin-bottom: 8px;}
.group_manage_toolbar{display:flex;justify-content:flex-end;margin-bottom:12px;}
.group_manage_body{min-height:120px;max-height:420px;overflow-y:auto;}
.batch_group_tip{font-size:13px;color:#606266;}
.product_group_tag{display:inline-flex;align-items:center;max-width:100%;padding:2px 8px;border:1px solid #f7c7c7;border-radius:10px;background:#fff4f1;font-size:12px;line-height:1.3;color:#d84a33;word-break:break-all;}
.product_group_tag_empty{border-style:dashed;border-color:#dcdfe6;background:#fafafa;color:#c0c4cc;}

:deep(.product-group-manage-dialog){display:flex;flex-direction:column;max-height:560px;}
:deep(.product-group-manage-dialog .el-dialog__body){overflow:hidden;padding-top:16px;padding-bottom:18px;}

:deep(.el-table th.el-table__cell>.cell){padding: 0 4px !important;}
:deep(.el-table td.el-table__cell>.cell){padding: 0 5px !important;font-size: 13px;}
:deep(.el-table .el-table__row td){height: 40px;}
.el-table .cell{white-space: nowrap;text-overflow: initial;}

/* 区间筛选下拉面板样式 */
:deep(.el-select-dropdown){min-width: 200px !important;}
:deep(.el-select-dropdown__item){padding: 0 !important;}
</style>

<style>
/* 区间筛选自定义下拉面板（全局，因为 el-select 下拉渲染在 body） */
.range-select-dropdown {
  min-width: 240px !important;
}
.range-select-dropdown .el-select-dropdown__item {
  padding: 8px 12px !important;
  line-height: normal !important;
  height: auto !important;
}
.range-select-dropdown .el-select-dropdown__item.selected {
  font-weight: normal !important;
}
.range-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
}
/* 自定义输入框容器样式 */
.range-select-dropdown .custom-range-input {
  padding: 8px 0 !important;
  pointer-events: auto !important;
}
.range-select-dropdown .custom-range-input:hover {
  background-color: transparent !important;
}
/* 确保自定义输入框的 el-option 不会关闭下拉 */
.range-select-dropdown .el-select-dropdown__item.hover {
  background-color: #f5f7fa !important;
}
.range-select-dropdown .custom-range-input .el-input__inner {
  pointer-events: auto !important;
}
</style>
